
export interface EnvConfig {
  API_BASE_URL: string;
  NODE_ENV: string;
  APP_NAME: string;
  VERSION: string;
}

const localApiBaseUrl = typeof window !== 'undefined'
  ? `${window.location.protocol}//${window.location.hostname}:8080`
  : 'http://localhost:8080';

export const ENV_CONFIG: EnvConfig = {
  API_BASE_URL: (import.meta as any).env?.VITE_API_BASE_URL || localApiBaseUrl,
  NODE_ENV: (import.meta as any).env?.MODE || 'development',
  APP_NAME: 'Real Estate Management System',
  VERSION: '1.0.0'
};
export const isDevelopment = (): boolean => ENV_CONFIG.NODE_ENV === 'development';
export const isProduction = (): boolean => ENV_CONFIG.NODE_ENV === 'production';
